import { Component} from '@angular/core';
import { LoginService } from '../../services/login.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Router} from "@angular/router";
import Swal from 'sweetalert2'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent {
  cuit_cliente: any='';
  cuit_user: any='';
  password: any='';

  constructor(public loginService:LoginService, public httpClient:HttpClient, private router: Router) {};


  login(){
    this.loginService.login(this.cuit_cliente,this.cuit_user,this.password)
    .then((data:any)=>{
      if(parseInt(data.error)) {
        //ACA VA LA ALERTA!! :)
        Swal.fire({
          title: 'Oops...',
          text: data.mensaje ,
          showCancelButton: true,
          cancelButtonText: `Olvidaste tu contraseña?`,
          confirmButtonText: `Volver a intentar`,
          // footer: '<a href="/login">Olvidaste tu contraseña?</a>'
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isDismissed) {
            Swal.fire({
              text: 'Segui estos pasos para recuperar tu contraseña',
              imageUrl: 'assets/img/inst.png',
              imageWidth: 500,
              imageHeight: 300,
              imageAlt: 'Instrucciones para recuperar password',
            })
          }
        })
      } else { 
        this.loginService.setearUsuario();

        if(localStorage.getItem('nro_cliente')!=''&&localStorage.getItem('nro_proveedor')===''){
          this.router.navigate(['home/facturas']);
        } else if(localStorage.getItem('nro_proveedor')!=''&&localStorage.getItem('nro_cliente')===''){
          this.router.navigate(['home/op']);
        } else
        {
          this.router.navigate(['home/facturas']);
        }
      }
  })

  }


  recover(){ /// cambiar el alert por un pop up con estilo
    this.loginService.recover(this.cuit_cliente,this.cuit_user).then((data:any)=>{
      if(parseInt(data.error)){
        Swal.fire({
          title: 'Oops...',
          text: data.mensaje
        })
      } else {
        Swal.fire({
          title: 'Recuperacion exitosa',
          text: data.mensaje
        })
      }
  })
}

test(){
/// solo para test
const headers = new HttpHeaders({'Content-Type': 'application/json'});
let path = '/api/hola';

const params={
  'username':'test'
}

 this.httpClient.post(path,params,{headers})
 .subscribe(response => response);

}




}
